import Hr from './hr';

export default Hr;
